import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useBasket } from './useBasket';
import type { HttpParams } from '../../utils/url-utils';
import type { PaymentMethodsResponse } from './model';

interface UsePaymentMethodsParams {
    productId?: string;
    isExpress?: boolean;
}

export const usePaymentMethods = (
    params?: UsePaymentMethodsParams,
): UseQueryResult<PaymentMethodsResponse> => {
    const { productId = '', isExpress = false } = params ?? {};
    const { data } = useBasket();
    const httpParams: HttpParams = [{ isExpress }];

    if (productId) {
        httpParams.push({ productId });
    }

    return useBffGet<PaymentMethodsResponse>(
        `/baskets/${data?.basketId}/payment-methods`,
        httpParams,
        [BffQueryKey.PAYMENT_METHODS, productId, isExpress.toString(), String(data?.basketId)],
        {
            basketCustomerId: data?.customerInfo?.customerId,
            enabled: !!data?.basketId,
            staleTime: Infinity,
        },
    );
};
